import { render } from "./TitleWithSub.vue?vue&type=template&id=1a1eb991&scoped=true"
import script from "./TitleWithSub.vue?vue&type=script&lang=js"
export * from "./TitleWithSub.vue?vue&type=script&lang=js"

import "./TitleWithSub.vue?vue&type=style&index=0&id=1a1eb991&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a1eb991"

export default script